import { Box, Divider, Drawer, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material'
import React, { useState } from 'react'
import MenuIcon from '@mui/icons-material/Menu';
import { pastelOrange } from '../Pages/Main/constants';
import { navigation } from './Navbar';
import { Motion } from './Motion';
import { useLocation, useNavigate } from 'react-router-dom';
import ContentPasteRoundedIcon from '@mui/icons-material/ContentPasteRounded';

const additions = [{ path: "/dokumenty", name: "Dokumenty", icon: ContentPasteRoundedIcon },];

export default function NavbarDrawer() {
    const [open, setOpen] = useState(false);
    const location = useLocation();
    const currentPath = location.pathname;
    const navigate = useNavigate();

    const toggleDrawer = (newOpen) => () => {
        setOpen(newOpen);
    };

    const onNavClick = (e, data) => {
        let timeout = 0;
        if (data?.path !== currentPath) {
            timeout = 200;
            navigate(data.path);
        }
        if (data?.id) {
            setTimeout(() => {
                const el = document.getElementById(data.id);
                if (el) {
                    el.scrollIntoView({ behavior: "smooth", block: 'start' });
                }
            }, timeout);
        }
    };

    return (
        <div>
            <Motion scale={1.03}>
                <IconButton
                    size="large"
                    edge="end"
                    color="inherit"
                    aria-label="menu"
                    sx={{ mr: 2, boxShadow: "1px 2px 5px 0px rgba(115,117,122,0.5)", bgcolor: pastelOrange, "&:hover": { bgcolor: pastelOrange } }}
                    onClick={() => {
                        setOpen(prev => !prev);
                    }}
                >
                    <MenuIcon sx={{ color: 'white' }} />
                </IconButton>
            </Motion>
            <Drawer anchor={"right"} open={open} onClose={toggleDrawer(false)}
                PaperProps={{ sx: { bgcolor: "rgba(255, 173, 102, 0.95)" } }}>
                <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)}>
                    <List sx={{ mt: '60px' }}>
                        {navigation.map((data, index) => {
                            const Icon = data.icon;
                            return (
                                <ListItem key={data.name} disablePadding>
                                    <ListItemButton sx={{ py: '16px' }} onClick={(e) => onNavClick(e, data)}>
                                        <ListItemIcon>
                                            <Icon sx={{ color: 'white', mx: '12px' }} />
                                            {/*index % 2 === 0 ? <InboxIcon /> : <MailIcon />*/}
                                        </ListItemIcon>
                                        <ListItemText primary={data.name} sx={{ color: 'white', ml: '12px' }} />
                                    </ListItemButton>
                                </ListItem>
                            )
                        })}
                        <Divider sx={{ bgcolor: 'white', my: '16px' }} />
                        {additions.map((data, index) => {
                            const Icon = data.icon;
                            return (
                                <ListItem key={data.name} disablePadding>
                                    <ListItemButton sx={{ py: '16px' }} onClick={(e) => onNavClick(e, data)}>
                                        <ListItemIcon>
                                            <Icon sx={{ color: 'white', mx: '12px' }} />
                                            {/*index % 2 === 0 ? <InboxIcon /> : <MailIcon />*/}
                                        </ListItemIcon>
                                        <ListItemText primary={data.name} sx={{ color: 'white', ml: '12px' }} />
                                    </ListItemButton>
                                </ListItem>
                            )
                        })}
                    </List>
                </Box>
            </Drawer>
        </div>
    )
}
